import axios from "axios";
import config from "../../config";

import { useEffect, useState } from "react";
import useAuthenticate from "../authentication/authenticate.js";
import ProfileDropdown from "./profileDropdown.js";

const PageHeader = ({ pageName }) => {
  const { user } = useAuthenticate();
  const [propertyRole, setPropertyRole] = useState(null);

  const role = Object.keys(user?.active || {})[0]; // 'manager', 'owner', etc.
  const accountName = user?.name || "User Name";

  useEffect(() => {
    const fetchPropertyRole = async () => {
      try {
        const res = await axios.get(`${config.API_URL}/v2/role/propertyRole`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
        });
        setPropertyRole(res.data);
      } catch (err) {
        console.error("❌ Failed to fetch property role:", err);
      }
    };

    fetchPropertyRole();
  }, []);

  return (
    <div>
      <div className="header mb-8">
        <h1 className="text-3xl font-bold">{pageName}</h1>
        <div className="hidden md:block">
          <div className="header-right">
            <p className="flex items-center mr-4">{accountName}</p>
            {propertyRole && (
              <ProfileDropdown
                user={user}
                role={role}
                account={propertyRole[0].account._id}
                property={propertyRole[0].property._id}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
